import i18n from 'modules/core/lib/i18n'

export class PermissionsErrorResolver {
  private statusCode: number
  private errorCode?: string
  private errorMessage?: string

  constructor(statusCode: number, errorCode?: string, errorMessage?: string) {
    this.statusCode = statusCode
    this.errorCode = errorCode
    this.errorMessage = errorMessage
  }

  get shouldShow(): boolean {
    return (
      !!this.errorCode ||
      !Number.isFinite(this.statusCode) ||
      (this.statusCode > 0 && this.statusCode !== 200)
    )
  }

  get description(): string {
    if (!Number.isFinite(this.statusCode)) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_permissions'
      )
    }

    if (this.statusCode === 401) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.auth_expired'
      )
    }

    if (this.statusCode === 403) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_permissions'
      )
    }

    if (this.statusCode === 504) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_rz_komm_subscription'
      )
    }

    if (this.errorMessage?.toLowerCase().includes('client is not activated for data exchange')) {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.not_activated_for_data_exchange'
      )
    }

    if (this.errorCode === '#DCO02401') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.not_enabled_lohnaustauschdatenservice'
      )
    }

    if (this.errorCode === '#DCO02431') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.no_rz_komm_subscription'
      )
    }

    if (this.errorCode === '#DCO02442') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.on_premise_internal_error'
      )
    }

    if (this.errorCode === '#DCO02447') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.on_premise_unavailable'
      )
    }

    if (this.errorCode === '#DCO02402' || this.errorCode === '#DXLO02409') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.wrong_mandantennummer'
      )
    }

    if (this.errorCode === 'LN22611') {
      return i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.lug_client_data_retrieval_failed'
      )
    }

    return i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.permission_errors.other_errors'
    )
  }
}
